$shm_hitalama_teams_token $mol_password
	Pass $mol_string
		type <= type
		hint <= hint \
		value? <=> value? \
		submit? <=> submit? null
		enabled <= enabled true
		autocomplete_native \new-password

$shm_hitalama_teams $mol_book2
	menu_title \Моя команда
	pages <= team_pages /
	New_page $shm_hitalama_guide_page
		title \Новая команда
		help_section \team
		body /
			<= New_form $mol_form
				form_fields /
					<= New_name_field $mol_form_field
						name \Название
						Content <= New_name $mol_string
							value? <=> new_name? \
							hint \Название команды
					<= New_api_url_field $mol_form_field
						name \URL Projects API
						Content <= New_api_url $mol_string
							value? <=> new_api_url? \
							hint \https://projects-dev.example.org/
							autocomplete_native \url
					<= New_api_token_field $mol_form_field
						name \Токен Projects API
						Content <= New_api_token $shm_hitalama_teams_token
							value? <=> new_api_token? \
					<= New_status $mol_status
						message <= team_create_status \
						style *
							color <= team_create_status_color \
				buttons /
					<= New_submit $mol_button_major
						title \Создать
						enabled <= team_create_enabled false
						click? <=> team_create? null
	Team_menu_page $shm_hitalama_guide_page
		title <= selected_team_name \
		help_section \team
		tools /
			<= Team_picker $mol_pick
				align_hor \left
				trigger_content /
					<= Team_picker_icon $mol_icon_dots_vertical
				bubble_content /
					<= Team_picker_options $mol_list
						rows <= team_picker_rows /
		body / <= Team_menu $mol_list
			rows /
				<= Team_info_link $mol_link
					uri <= team_tab_uri*info \
					title \Общая информация
					current <= team_tab_current*info false
				<= Team_members_link $mol_link
					uri <= team_tab_uri*members \
					title \Участники
					current <= team_tab_current*members false
				<= Team_maps_link $mol_link
					uri <= team_tab_uri*maps \
					title \Совместные карты
					current <= team_tab_current*maps false
	Team_create_link $mol_link
		uri <= team_new_uri \
		title \Создать новую
		click? <=> team_new_click? null
	Team_select $mol_select
		dictionary <= team_options *
		value? <=> team_id? \
	Detail_page $mol_page
		title <= selected_team_tab_title \
		body <= detail_content /$mol_view
	Info $mol_view
		sub /
			<= Settings_form $mol_form
				form_fields /
					<= Team_name_field $mol_form_field
						name \Название
						Content <= Team_name $mol_string
							value? <=> selected_team_name? \
							enabled <= team_manage_allowed false
					<= Team_api_url_field $mol_form_field
						name \URL Projects API
						Content <= Team_api_url $mol_string
							value? <=> selected_team_api_url? \
							enabled <= team_manage_allowed false
							autocomplete_native \url
					<= Team_api_token_field $mol_form_field
						name \Токен Projects API
						Content <= Team_api_token $shm_hitalama_teams_token
							value? <=> selected_team_api_token? \
							enabled <= team_manage_allowed false
					<= Team_creator_field $mol_form_field
						name \Создатель
						Content <= Team_creator $mol_text
							text <= selected_team_creator \
				buttons /
	Members_section $mol_view
		sub /
			<= Member_add_row $mol_view
				sub /
					<= Member_id $mol_string
						value? <=> member_id? \
						hint \ID клиента
						enabled <= team_manage_allowed false
					<= Member_add $mol_button_major
						title \Добавить
						enabled <= member_add_enabled false
						click? <=> member_add? null
			<= Member_add_status $mol_status
				style *
					color <= member_add_status_color \
				message <= member_add_status \
			<= Members $mol_view
				sub /
					<= Members_head $mol_view
						sub /
							<= Member_name_head $mol_view
								sub / \Участник
							<= Member_id_head $mol_view
								sub / \ID
							<= Member_admin_head $mol_view
								sub / \Администратор
					<= Member_rows $mol_list
						rows <= member_rows /
	Team_maps $shm_hitalama_teams_maps
	Team_maps_empty_page $mol_page
		title \Карты
		body /
			<= Team_maps_empty $mol_text
				text \Каталог карт пока не создан. Попросите администратора команды открыть этот раздел.
	Member_row* $mol_view
		sub /
			<= Member_name* $mol_link
				uri <= member_uri* \
				title <= member_name* \
				sub / <= Member_badge* $shm_hitalama_profile_badge
					name <= member_name* \
					avatar_uri <= member_avatar_uri* \
			<= Member_user_id* $mol_view
				sub / <= member_user_id* \
			<= Member_admin* $mol_check_box
				title \
				checked? <=> member_admin*? false
				enabled <= member_admin_enabled* false
	Member_page $mol_page
		title <= selected_member_name \
		body / <= Member_detail $mol_view
			sub /
				<= Member_meta $mol_view
					sub /
						<= Selected_member_name_field $mol_form_field
							name \Имя
							Content <= Selected_member_name $mol_text
								text <= selected_member_name \
						<= Selected_member_id_field $mol_form_field
							name \ID
							Content <= Selected_member_id $mol_text
								text <= selected_member_user_id \
				<= Permissions_title $mol_view
					sub / \Права на проекты
				<= Permissions $mol_view
					sub /
						<= Permission_head $mol_view
							sub /
								<= Project_head $mol_view
									sub / \Проект
								<= Visible_head $mol_view
									sub / \Отображение
								<= Prerelease_head $mol_view
									sub / \Пререлизы
								<= Release_head $mol_view
									sub / \Релизы
						<= Permission_rows $mol_list
							rows <= permission_rows /
	Permission_row* $mol_view
		sub /
			<= Project_title* $mol_view
				sub / <= project_title* \
			<= Project_visible* $mol_check_box
				title \
				checked? <=> project_visible*? false
				enabled <= permission_manage_allowed false
			<= Project_prerelease* $mol_check_box
				title \
				checked? <=> project_prerelease*? false
				enabled <= permission_manage_allowed false
			<= Project_release* $mol_check_box
				title \
				checked? <=> project_release*? false
				enabled <= permission_manage_allowed false
